module.exports = __webpack_public_path__ + "static/slide4-318x245-b4f3f69508caa8d68c1eeecda42411e0.gif";